<template>
  <table>
        <tr v-for="(metric, id) in data" :key="id">
            <td v-for="(value, id) in metric" :key="id" :class="[id == 0 ? 'highlighted bold yellow' : '']">{{value}}</td>
        </tr>
    </table>
</template>

<script>
export default {
  name: "Metrics",
  data: () => ({}),
  components: {},
  mounted() {},
  props: { data: Array },
};
</script>


<style lang="scss" scoped>
    table   {
        border-spacing: 1px;
        width:665px;
        margin-bottom: 1em;        
    }
    td {
        background-color: rgba(#FFFFFF, 0.1);
        color: #B2B3B8;
        font-family: 'Montserrat';
        font-size: 0.85em;
        letter-spacing: 0;
        line-height: 1;
        padding:1.3rem 1rem;        
    }
    .center {
        text-align: center;
        color:#fff;
        white-space: nowrap;
    }
    .white {
        color:#fff;
        margin-right:10px;
    }
    .details {
        text-transform: uppercase;
        font-size: 0.9rem;
        vertical-align: baseline;
        display: inline-block;
        break-inside:avoid;
        line-height: 1.2;
        margin-top:2px;
    }    
    .highlighted {
        text-shadow: 0 0 10px rgba(255,255,255,0.34);
        font-weight: bold;
    }
    .bold {
        font-weight: bold;
    }
    .headers td {
        background-color: rgba(#000, 0.35);
        padding:1.2em 2em;
        font-size: 0.9em;
    }
</style>
